import * as React from 'react';
import * as style from './style.css';
import { Label, UIText1 } from '@cian/ui-kit';
import { Link } from '../Link';
import { DecorationLabel } from '../Labels';
import { Compare } from '../Compare';
import { Favorite } from '../Favorite';
import { IconFunctionalLock16 } from '@cian/ui-kit-design-tokens/icons';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const OffersRow = _ref => {
  var _offer$discount, _offer$discount2;
  let {
    offer,
    onOfferLinkClick
  } = _ref;
  return /*#__PURE__*/_jsxs("div", {
    className: style['row'],
    children: [/*#__PURE__*/_jsx("a", {
      className: style['link-area'],
      href: offer.url,
      target: "_blank",
      onClick: onOfferLinkClick,
      rel: "noreferrer"
    }), /*#__PURE__*/_jsxs("div", {
      className: style['offer-title'],
      children: [/*#__PURE__*/_jsx(UIText1, {
        children: /*#__PURE__*/_jsx(Link, {
          children: offer.title
        })
      }), /*#__PURE__*/_jsxs("div", {
        className: style['labels'],
        children: [offer.isBooked && /*#__PURE__*/_jsx(Label, {
          background: "accent-ghost-primary",
          color: "text-inverted-default",
          children: "\u0417\u0430\u0431\u0440\u043E\u043D\u0438\u0440\u043E\u0432\u0430\u043D\u0430"
        }), offer.hasDecoration && /*#__PURE__*/_jsx(DecorationLabel, {}), ((_offer$discount = offer.discount) === null || _offer$discount === void 0 ? void 0 : _offer$discount.discountLabel) && /*#__PURE__*/_jsx(Label, {
          background: "accent-positive-secondary",
          color: "accent-positive-primary",
          children: offer.discount.discountLabel
        })]
      })]
    }), /*#__PURE__*/_jsx("div", {
      className: style['description-cell'],
      children: /*#__PURE__*/_jsx(UIText1, {
        color: "current_color",
        children: offer.dueDate
      })
    }), /*#__PURE__*/_jsx("div", {
      className: style['description-cell'],
      children: /*#__PURE__*/_jsx(UIText1, {
        color: "current_color",
        children: offer.floor
      })
    }), /*#__PURE__*/_jsx("div", {
      className: style['description-cell'],
      children: /*#__PURE__*/_jsxs("div", {
        className: style['price'],
        children: [/*#__PURE__*/_jsxs("div", {
          className: style['price-row'],
          children: [offer.isBooked && /*#__PURE__*/_jsx("div", {
            className: style['icon'],
            children: /*#__PURE__*/_jsx(IconFunctionalLock16, {
              display: "block",
              color: "decorative-magentum"
            })
          }), /*#__PURE__*/_jsx(UIText1, {
            color: offer.isBooked ? 'text-secondary-default' : 'text-primary-default',
            textAlign: "right",
            as: "span",
            children: offer.price
          })]
        }), ((_offer$discount2 = offer.discount) === null || _offer$discount2 === void 0 ? void 0 : _offer$discount2.oldPrice) && /*#__PURE__*/_jsx("span", {
          className: style['old-price'],
          children: offer.discount.oldPrice
        })]
      })
    }), /*#__PURE__*/_jsxs("div", {
      className: style['controls-cell'],
      children: [/*#__PURE__*/_jsx(Compare, {
        status: offer.offersComparisonStatus.status,
        offerId: offer.id
      }), /*#__PURE__*/_jsx(Favorite, {
        isFavorite: offer.isFavorite,
        offerId: offer.id
      })]
    })]
  });
};